export default __webpack_public_path__ + "static/173-7d2e092eabebc34da6e63da69c9a8e97.gif";